export const WOW_DATE_FIELD = 'lastupdatedon';

export type WowStatsFeature = {
  properties: {
    category: string;
    categoryid: string;
    datasource: string;
    lastupdatedon: string;
    threat: string;
    threatdescription: string;
    threatlevel: string;
    county_intersect: string;
    initial_date: string;
    residential_struc_exposed: number;
    state_intersect: string;
    structures_exposed: number;
    threat_id: string;
    time_category: string;
  };
};
